import { useState } from "react";
import { Video, Upload } from "lucide-react";
import { colors, fonts } from "../styles/theme";
import { MeetingsList } from "../features/meetings";
import { VideoLibrary } from "../features/video-library";

const TABS = [
  { id: "recordings", label: "Recordings", icon: Video },
  { id: "uploads", label: "Uploads", icon: Upload },
];

export default function Meetings() {
  const [tab, setTab] = useState("recordings");

  return (
    <div>
      {/* Page header + tabs */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          marginBottom: 24,
        }}
      >
        <div>
          <h1
            style={{
              fontFamily: fonts.heading,
              fontSize: 28,
              fontWeight: 700,
              color: colors.text,
              marginBottom: 12,
            }}
          >
            Videos
          </h1>
          <div style={{ display: "flex", gap: 0 }}>
            {TABS.map((t) => {
              const Icon = t.icon;
              const active = tab === t.id;
              return (
                <button
                  key={t.id}
                  onClick={() => setTab(t.id)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    padding: "8px 16px",
                    fontSize: 13,
                    fontWeight: active ? 600 : 400,
                    fontFamily: fonts.body,
                    color: active ? colors.accent : colors.textSecondary,
                    background: "none",
                    border: "none",
                    borderBottom: active
                      ? `2px solid ${colors.accent}`
                      : "2px solid transparent",
                    cursor: "pointer",
                    transition: "all 0.15s",
                  }}
                >
                  <Icon size={14} />
                  {t.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Tab content */}
      {tab === "recordings" ? (
        <MeetingsList embedded />
      ) : (
        <VideoLibrary embedded />
      )}
    </div>
  );
}
